class MiniCart extends HTMLElement {
  constructor() {
    super();
    var t = this;
    this.renderCart();
    this.sectionId =
      "shopify-section-" + this.querySelector(".minicart-container").dataset.sectionId;
    this._onViewport = function () {
      t.pinToVisualViewport();
    };
    document.addEventListener("shopify:section:load", function (e) {
      t.sectionId == e.target.id && (t.renderCart(), t.show());
    });
    document.addEventListener("shopify:section:select", function (e) {
      t.sectionId == e.target.id && (t.renderCart(), t.show());
    });
    document.addEventListener("shopify:block:select", function (e) {
      document.querySelector("#" + t.sectionId + " #block--" + e.target.id) &&
        (t.renderCart(), t.show());
    });
    window.on(
      "resize",
      theme.utils.debounce(300, function () {
        500 < document.documentElement.clientWidth && t.renderCart();
        t.pinToVisualViewport();
      })
    );
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this._onViewport);
      window.visualViewport.addEventListener("scroll", this._onViewport);
    }
    document.addEventListener("click", (e) => {
      if (!t.details || !t.details.hasAttribute("open")) return;
      if (e.target.closest("summary")) return;
      if (e.target.closest("mini-cart, .minicart-content")) return;
      /* répondre à la bannière cookies ne doit pas fermer le panier */
      if (e.target.closest("#shopify-pc__banner, #shopify-pc__prefs__dialog, #shopify-pc__prefs__overlay, .shopify-pc__prefs__overlay")) return;
      t.hide();
    });
  }

  pinToVisualViewport() {
    var open = this.details && this.details.hasAttribute("open");
    var desktop =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(min-width: 780px)").matches;
    var vv = window.visualViewport;
    var height = vv && vv.height ? vv.height : window.innerHeight;
    var offsetTop = vv && typeof vv.offsetTop === "number" ? vv.offsetTop : 0;
    if (!open || desktop) {
      this.style.removeProperty("--minicart-vv-height");
      this.style.removeProperty("--minicart-vv-top");
      return;
    }
    this.style.setProperty("--minicart-vv-height", Math.round(height) + "px");
    this.style.setProperty("--minicart-vv-top", Math.round(offsetTop) + "px");
  }

  _lockBody(scrollY) {
    if (document.body.classList.contains("overflow-hidden-fixed")) return;
    var y =
      typeof scrollY === "number"
        ? scrollY
        : window.scrollY || window.pageYOffset || 0;
    document.body.style.top = `-${y}px`;
    document.body.classList.add("overflow-hidden-fixed");
  }

  _schedulePin() {
    var t = this;
    t.pinToVisualViewport();
    requestAnimationFrame(function () {
      t.pinToVisualViewport();
    });
    setTimeout(function () {
      t.pinToVisualViewport();
    }, 120);
  }

  bindEvents() {
    var t = this;
    this.details = this.closest("details");
    this.querySelector(".modal__close") &&
      this.querySelector(".modal__close").addEventListener("click", function () {
        this.closest("details[open]") &&
          (this.closest("details[open]").removeAttribute("open"),
          (this.scrollY = document.body.style.top),
          (document.body.style.top = ""),
          document.body.classList.remove("overflow-hidden-fixed"),
          window.scrollTo({
            left: 0,
            top: -1 * parseInt(this.scrollY || "0"),
            behavior: "instant",
          }),
          t.pinToVisualViewport());
      });
    if (this.details && !this._toggleBound) {
      this._toggleBound = true;
      this.details.addEventListener("toggle", function () {
        if (t.details.hasAttribute("open")) {
          if (!t.details.classList.contains("disclosure-has-popup")) {
            t._lockBody();
            t._schedulePin();
          }
          return;
        }
        /* fermé par n'importe quel moyen (dont « PANIER » dans l'en-tête) :
           toujours déverrouiller la page, sinon elle reste figée */
        t.hide();
      });
    }
  }

  show() {
    var y = window.scrollY || window.pageYOffset || 0;
    this.details.setAttribute("open", "");
    this.details.classList.contains("disclosure-has-popup") &&
      (this._lockBody(y), this.details.classList.add("menu-opening"));
    this._schedulePin();
  }

  open() {
    if (
      ("once" != Shopify.theme_settings.atc_action || sessionStorage.getItem("miniCartOpen")) &&
      "always" != Shopify.theme_settings.atc_action
    )
      return;
    if (
      this.details &&
      this.details.hasAttribute("open") &&
      document.body.classList.contains("overflow-hidden-fixed")
    ) {
      this._schedulePin();
      return;
    }
    var y = window.scrollY || window.pageYOffset || 0;
    this.details.setAttribute("open", "");
    if (this.details.classList.contains("disclosure-has-popup")) {
      this._lockBody(y);
      if (y > 0 && document.querySelector("#shopify-header-section")) {
        document
          .querySelector("#shopify-header-section")
          .classList.add("scrolled-past-header", "shopify-section-header-sticky", "animate");
      }
      this.details.classList.add("menu-opening");
    }
    "once" != Shopify.theme_settings.atc_action ||
      sessionStorage.getItem("miniCartOpen") ||
      sessionStorage.setItem("miniCartOpen", !0);
    this._schedulePin();
  }

  hide() {
    if (!this.details) return;
    this.details.removeAttribute("open");
    this.details.classList.remove("menu-opening");
    if (document.body.classList.contains("overflow-hidden-fixed")) {
      var scrollY = document.body.style.top;
      document.body.style.top = "";
      document.body.classList.remove("overflow-hidden-fixed");
      window.scrollTo({
        left: 0,
        top: -1 * parseInt(scrollY || "0", 10),
        behavior: "instant",
      });
    }
    this.pinToVisualViewport();
  }

  renderCart() {
    this.querySelector(".minicart-content .minicart-container") &&
      this.querySelector(".minicart-content .minicart-container").remove();
    document.querySelector(".minicart-section") &&
      (this.querySelector(".minicart-content").innerHTML += document
        .querySelector(".minicart-section")
        .cloneNode(!0).innerHTML);
    this.bindEvents();
    this.pinToVisualViewport();
  }
}
customElements.define("mini-cart", MiniCart);
